import { Stack, Title, Radio } from "@mantine/core";
import { TextInput, RadioGroup } from "react-hook-form-mantine";
import CustomFieldsRenderer from "./CustomFieldsRenderer";
import { useTranslation } from "react-i18next";

export default function BillingInformation({
  control,
  registrationType,
  registrationCustomFields,
}) {
  const { t } = useTranslation();
  const isCompany = registrationType === "company";

  return (
    <Stack gap="md">
      <RadioGroup
        control={control}
        name="type"
        label={t("select_registration_type")}
        required
      >
        <Stack mt="xs">
          <Radio value="individual" label={t("individual")} />
          <Radio value="company" label={t("company")} />
        </Stack>
      </RadioGroup>

      <Title order={5} mt="md">
        {t("billing_information")}
      </Title>

      <TextInput
        control={control}
        name="firstName"
        label={t("first_name")}
        withAsterisk={!isCompany}
        placeholder={t("enter_first_name")}
      />

      <TextInput
        control={control}
        name="lastName"
        label={t("last_name")}
        withAsterisk={!isCompany}
        placeholder={t("enter_last_name")}
      />

      <TextInput
        control={control}
        name="email"
        label={t("email")}
        type="email"
        placeholder={t("enter_email")}
        withAsterisk
      />

      {isCompany && (
        <>
          <TextInput
            control={control}
            name="companyName"
            label={t("company_name")}
            withAsterisk
            placeholder={t("enter_company_name")}
          />

          <TextInput
            control={control}
            name="vatNumber"
            label={t("vat_number")}
            placeholder={t("enter_vat_number")}
          />
        </>
      )}

      {registrationCustomFields?.length > 0 && (
        <>
          <Title order={5} mt="md">
            {t("additional_information")}
          </Title>
          <CustomFieldsRenderer
            control={control}
            customFields={registrationCustomFields}
          />
        </>
      )}
    </Stack>
  );
}
